
const m = window.require("fetch");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
